/* ==========================================================================
   Mondō London: privacy ledger
   Shopify Customer Privacy API controls the first appearance and persistence.
   Reopening the ledger restores the visitor's current optional choices before
   anything can be saved again.
   ========================================================================== */
(function () {
  'use strict';

  var card = document.querySelector('[data-consent]');
  if (!card) return;

  var analytics = card.querySelector('[data-consent-analytics]');
  var marketing = card.querySelector('[data-consent-marketing]');
  var preferencesPanel = card.querySelector('[data-consent-prefs]');
  var preferencesToggle = card.querySelector('[data-consent-prefs-toggle]');
  var title = card.querySelector('[data-consent-title]');
  var error = card.querySelector('[data-consent-error]');
  var api = null;
  var hideTimer = null;
  var pendingDecision = null;

  function announce(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  function clearError() {
    if (!error) return;
    error.hidden = true;
  }

  function showError() {
    pendingDecision = null;
    if (!error) return;
    error.hidden = false;
  }

  function setPreferencesOpen(open) {
    if (preferencesPanel) preferencesPanel.hidden = !open;
    if (preferencesToggle) {
      preferencesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function readVisitorConsent() {
    if (!api || !api.currentVisitorConsent) return;
    try {
      return api.currentVisitorConsent();
    } catch (e) {
      return null;
    }
  }

  function isRecorded(value) {
    return value === 'yes' || value === 'no';
  }

  function hasRecordedDecision(current) {
    return !!current &&
      isRecorded(current.analytics) &&
      isRecorded(current.marketing) &&
      isRecorded(current.preferences);
  }

  function decisionMatches(current, expected) {
    if (!current || !expected) return false;
    return current.analytics === (expected.analytics ? 'yes' : 'no') &&
      current.marketing === (expected.marketing ? 'yes' : 'no') &&
      current.preferences === (expected.preferences ? 'yes' : 'no');
  }

  function restoreChoices() {
    var current = readVisitorConsent();
    if (!current) return;
    if (analytics) analytics.checked = current.analytics === 'yes';
    if (marketing) marketing.checked = current.marketing === 'yes';
  }

  function needsNotice() {
    if (!api || !api.shouldShowBanner) return false;
    try {
      return api.shouldShowBanner() && !hasRecordedDecision(readVisitorConsent());
    } catch (e) {
      return false;
    }
  }

  function show(focusTitle) {
    var wasHidden = card.hidden;
    if (hideTimer !== null) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    clearError();
    restoreChoices();
    card.hidden = false;
    requestAnimationFrame(function () {
      card.classList.add('is-in');
      if (focusTitle && title) title.focus();
    });
    if (wasHidden) announce('mondo:consent-opened');
  }

  function hide() {
    card.classList.remove('is-in');
    setPreferencesOpen(false);
    announce('mondo:consent-closed');
    hideTimer = setTimeout(function () {
      card.hidden = true;
      hideTimer = null;
    }, 300);
  }

  function completeDecision(expected) {
    if (!pendingDecision || pendingDecision !== expected) return;
    pendingDecision = null;
    hide();
  }

  function callbackHasError(first, second) {
    return !!(
      (first && (first.error || first.name === 'Error')) ||
      typeof first === 'string' ||
      (second && second.error)
    );
  }

  function decide(analyticsAllowed, marketingAllowed, preferencesAllowed) {
    clearError();
    if (pendingDecision) return;
    if (!api || !api.setTrackingConsent) {
      showError();
      return;
    }

    var decision = {
      analytics: analyticsAllowed,
      marketing: marketingAllowed,
      preferences: preferencesAllowed
    };
    pendingDecision = decision;

    try {
      api.setTrackingConsent(
        decision,
        function (first, second) {
          if (callbackHasError(first, second)) {
            showError();
            return;
          }
          /* Shopify invokes this callback after consent is captured. Do not
             immediately second-guess it with currentVisitorConsent(): Safari
             can expose the updated snapshot later than the callback. */
          completeDecision(decision);
        }
      );
    } catch (e) {
      showError();
    }
  }

  card.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest('[data-consent-accept]')) return decide(true, true, true);
    if (target.closest('[data-consent-decline]')) return decide(false, false, false);
    if (target.closest('[data-consent-save]')) {
      return decide(analytics.checked, marketing.checked, false);
    }
    if (target.closest('[data-consent-prefs-toggle]')) {
      setPreferencesOpen(preferencesPanel.hidden);
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest
      ? event.target.closest('[data-consent-summon]')
      : null;
    if (!trigger) return;
    event.preventDefault();
    show(true);
  });

  document.addEventListener('visitorConsentCollected', function () {
    if (pendingDecision && decisionMatches(readVisitorConsent(), pendingDecision)) {
      completeDecision(pendingDecision);
    }
  });

  function boot() {
    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (loadError) {
          if (loadError) return;
          api = window.Shopify.customerPrivacy;
          if (!api ||
              typeof api.currentVisitorConsent !== 'function' ||
              typeof api.setTrackingConsent !== 'function' ||
              typeof api.shouldShowBanner !== 'function') return;
          restoreChoices();
          if (needsNotice()) show(false);
        }
      );
    } catch (e) {}
  }

  if (window.Shopify && window.Shopify.loadFeatures) boot();
  else {
    window.addEventListener('load', function () {
      if (window.Shopify && window.Shopify.loadFeatures) boot();
    });
  }
})();
